function getMonthNames(props) {
  const { localeName = "en-EN", options } = props || {}, format = new Intl.DateTimeFormat(localeName, {
    month: options?.month || "long",
    ...options
  }).format;
  return Array.from(Array(12).keys()).map((m) => format(new Date(Date.UTC(2021, m % 12))));
}
const getMonthOptions = (props) => getMonthNames(props).map((name, index) => ({ value: index + 1, label: name })), getLocaleDate = ({
  localeName,
  options,
  date
}) => date ? new Intl.DateTimeFormat(
  localeName,
  options ?? {
    month: "2-digit",
    year: "numeric",
    day: "2-digit"
  }
).format(date) : "";
export {
  getLocaleDate,
  getMonthNames,
  getMonthOptions
};
//# sourceMappingURL=dateHelper.js.map
